import { render, staticRenderFns } from "./NotificationMain.vue?vue&type=template&id=5ed14938&scoped=true&"
import script from "./NotificationMain.vue?vue&type=script&lang=js&"
export * from "./NotificationMain.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMain.vue?vue&type=style&index=0&id=5ed14938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed14938",
  null
  
)

export default component.exports